<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import { useAuthStore } from '@/stores/auth'
  import BuyBackCreateModal from '@/views/app/buyback/create/modal-create.vue'
  import SaleCreateModal from '@/views/app/sale/create/modal-create.vue'
  import SidebarItem from './sidebar-item.vue'
  import SidebarItemGroup from './sidebar-item-group.vue'

  const auth = useAuthStore()

  const refSaleCreateModal = useTemplateRef('refSaleCreateModal')
  const refBuyBackCreateModal = useTemplateRef('refBuyBackCreateModal')
</script>

<template>
  <div>
    <sidebar-item
      :to="{ name: 'home' }"
      icon="i-far-chart-line">
      Dashboard
    </sidebar-item>

    <sidebar-item-group
      v-if="auth.userCan('SALE_CREATE') || auth.userCan('BUYBACK_CREATE') || auth.userCan('PRODUCT_UNIT_CREATE')"
      label="Transaksi">
      <sidebar-item
        v-if="auth.userCan('SALE_CREATE')"
        icon="i-far-cash-register"
        @click="refSaleCreateModal?.open()">
        Tambah Penjualan
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('BUYBACK_CREATE')"
        icon="i-far-hand-holding-dollar"
        @click="refBuyBackCreateModal?.open()">
        Tambah Buyback
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('PRODUCT_UNIT_CREATE')"
        :to="{name: 'product unit import'}"
        icon="i-far-file-invoice-dollar">
        Import No Serial
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Laporan">
      <sidebar-item
        v-if="auth.userCan('SALE_MENU')"
        :to="{ name: 'sale list' }"
        icon="i-far-receipt">
        Riwayat Penjualan
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('BUYBACK_MENU')"
        :to="{ name: 'buyback list' }"
        icon="i-far-file-invoice-dollar">
        Riwayat Buyback
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Produk">
      <sidebar-item
        v-if="auth.userCan('PRODUCT_MENU')"
        :to="{ name: 'product list' }"
        icon="i-far-rectangle-vertical">
        Produk
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('PRODUCT_UNIT_MENU')"
        :to="{ name: 'product unit list' }"
        icon="i-far-rectangle-list">
        No Serial
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Pengaturan">
      <sidebar-item
        v-if="auth.userCan('USER_MENU')"
        :to="{ name: 'user admin list' }"
        icon="i-far-user">
        Staff
      </sidebar-item>
      <sidebar-item
        v-if="auth.userCan('ROLE_MENU')"
        :to="{ name: 'role list' }"
        icon="i-far-shield-check">
        Hak Akses
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'change password' }"
        icon="i-far-user-lock">
        Ganti Password
      </sidebar-item>
    </sidebar-item-group>

    <sale-create-modal ref="refSaleCreateModal" />
    <buy-back-create-modal ref="refBuyBackCreateModal" />
  </div>
</template>

<style>
  @reference "@/assets/styles/main.css";

  :root {
    --sidebar-item-margin-top: calc(var(--spacing) * 1);
    --sidebar-item-height: calc(var(--spacing) * 10); /* 40px */
    --sidebar-item-dropdown-height: calc(var(--spacing) * 8); /* 36px */
  }
  .sidebar-item {
    @apply flex w-full items-center space-x-4 rounded px-2 pl-1 text-left;
    @apply bg-gray-400/10;

    margin-top: var(--sidebar-item-margin-top);
    height: var(--sidebar-item-height);

    &:hover,
    &.router-link-active {
      @apply bg-primary-500/40;
    }
  }

  .sidebar-item-icon {
    @apply shrink-0;
  }
  .sidebar-item-count {
    @apply bg-warning rounded px-2 py-0.5 text-xs text-white;
  }

  .sidebar-item-dropdown-content {
    @apply transition-all duration-200 overflow-hidden;
    @apply -mx-2 px-2; /* fixes focus ring from getting clipped */

    .sidebar-item {
      height: var(--sidebar-item-dropdown-height);
    }
    &.collapsed > * {
      @apply invisible;
    }
  }
</style>
